<template>
  <BoiteDesCouleurs1/>
</template>

<script>
// @ is an alias to /src
import BoiteDesCouleurs1 from '@/components/boites-des-couleurs/BoiteDesCouleurs1.vue'

export default {
  name: 'BoiteDesCouleurs1Page',
  components: {
    BoiteDesCouleurs1
  }
}
</script>
